import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { AddToWishlist } from '@sainsburys-tech/bolt'
import debounce from 'lodash.debounce'

import { fireWishlistToggled } from './WishListTracking'
import hasKeys from '../../helpers/hasKeys'

export class WishList extends Component {
  constructor(props) {
    super(props)

    this.state = { tooltipWidth: 350 }
    this.onResize = debounce(this.getComponentWidth, 500)
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  getComponentWidth = () => {
    this.setState({
      tooltipWidth: this.refs['pdp-wishlist'].getBoundingClientRect().width
    })
  }

  onUpdate = () => {
    const { partNumber, isChecked, userState } = this.props
    fireWishlistToggled({ partNumber, isChecked, userState })
  }

  render = () => {
    const { partNumber } = this.props
    const { tooltipWidth } = this.state
    const { onUpdate } = this

    const wishlistHeartOptions = {
      item: { partNumber },
      showMessage: true,
      messageData: ['Added to Your Wishlist', 'Add to Your Wishlist'],
      onUpdate,
      tooltipWidth,
      tooltipDurationToShow: 0
    }

    return (
      <div ref='pdp-wishlist' className='xs-row top-border'>
        <AddToWishlist.Button {...wishlistHeartOptions} />
      </div>
    )
  }
}

WishList.propTypes = {
  partNumber: PropTypes.string.isRequired,
  hasItems: PropTypes.bool,
  isChecked: PropTypes.bool
}

WishList.defaultProps = {
  hasItems: false,
  isChecked: false
}

function isInWishlist(state, props) {
  const list = state.userDetails.data.userState === 'LOGGEDIN' ? state.globalList : state.localList
  const { data = {} } = list
  const { wishlists = [] } = data
  const { items = [] } = (wishlists.length && wishlists[0]) || {}
  const byPartNumber = ({ partNumber, deleted }) => partNumber === props.partNumber && !deleted
  const filteredItems = items.filter(hasKeys)
  const inWishlist = filteredItems.find(byPartNumber) || false
  return inWishlist
}

const mapStateToProps = (state, props) => {
  const hasItems = AddToWishlist.getWishlistCount(state) > 0
  const isChecked = isInWishlist(state, props)
  const { userState } = state.userDetails.data

  return {
    hasItems,
    isChecked,
    userState
  }
}

export default connect(mapStateToProps)(WishList)
export { isInWishlist, mapStateToProps }
